<template>
    <div class="card panel">
        <div class="actions">
            <h3>Void Status</h3>
        </div>
        <div class="px-2 py-3">
            <p class="text-danger" v-if="form.is_void">This project is voided.</p>
            <p v-else>If the project is voided it won't be available for any type of change.</p>
            <toggle-button v-model="form.is_void" :width="60" :height="30" :disabled="form.isSubmitted" :labels="{checked: 'Yes', unchecked: 'No'}" @change="update"></toggle-button>
        </div>
    </div>
</template>
<script>
export default {

    props: {
        project: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            form: new Form({
                is_void: this.project.is_void
            }).dontClear()
        }
    },

    methods: {
        update: _.debounce(function () {
            this.form.post(`/projects/${this.project.slug}/mark-as-void`).then(response => {
                this.refreshPage()
            }).catch(errors => {
                Alert.error(errors.first())
            })
        }, 500)
    }
}
</script>
